// extracted by mini-css-extract-plugin
export const modalWrapper = "modal-with-image-module--modal-wrapper--BuAhU";
export const modalContent = "modal-with-image-module--modal-content--Sgra8";
export const modalImageCol = "modal-with-image-module--modal-image-col--2vIdo";
export const modalChildrenCol = "modal-with-image-module--modal-children-col--3ElVe";